import React from 'react';

import { TbAirConditioning } from "react-icons/tb";
import { GiTreeBranch } from "react-icons/gi";
import { FaSwimmingPool } from "react-icons/fa";
import { MdBalcony } from "react-icons/md";
import '../Amenities/Amenities.css'; 
import { MdChair } from "react-icons/md";

const Amenities = () => {
    return (
      <section className="amenities">
        <h1 className="amenities-heading">Our Up-Coming Amenities</h1>
        <div className="amenities-container">
          <div className="amenity">
            <TbAirConditioning className="amenity-icon" />
            <h4 className='a-h4'>Centrally Air-Conditioned Lobbies</h4>
          </div>
          <div className="divider"></div>
          <div className="amenity">
            <GiTreeBranch className="amenity-icon" />
            <h4 className='a-h4'>Abundant Green Area</h4>
          </div>
          <div className="divider"></div>
          <div className="amenity">
            <FaSwimmingPool className="amenity-icon" />
            <h4 className='a-h4'>Swimming Pool</h4>
          </div>
          <div className="divider"></div>
          <div className="amenity">
            <MdBalcony className="amenity-icon" />
            <h4 className='a-h4'>Wide Balcony</h4>
          </div>
          <div className="divider"></div>
          <div className="amenity">
            <MdChair className="amenity-icon" />
            <h4 className='a-h4'>Double-Height Club Area</h4>
          </div>
        </div>
      </section>
    );
  };
  
  export default Amenities;